export default __webpack_public_path__ + "static/quantum-computing-software-ai-2025-246b650a8cd90354b691d2594b798c5a.jpg";